<template>
  <v-text-field
    v-model="newMessage"
    autofocus
    @click:append-outer="saveMessage"
    append-outer-icon="add_circle"
    @keypress.enter="saveMessage"
    full-width
    dense
    hide-details
    placeholder="Create a new card..."
  ></v-text-field>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      newMessage: ''
    };
  },
  methods: {
    log(m) {
      console.log(m);
    },
    saveMessage() {
      console.log('save');
      console.log(this.$refs.newMessage);
      this.$emit('input', this.newMessage);
      this.newMessage = '';
    },
    focusNewMessage() {
      this.$nextTick(() => {
        this.$refs.newMessage.focus();
        this.$refs.newMessage.$el.getElementsByTagName('input')[1].focus();
        console.log(this.$refs.newMessage);
      });
    }
  }
};
</script>

<style></style>
